import { Link } from "react-router-dom";

const HeroSection: React.FC = () => (
  <section className="relative min-h-screen flex items-center overflow-hidden">
    {/* Background */}
    <div className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/b48f01d1e55d94e7f3e01908bb27492e.jpg"
        alt="Professional Hardware Tools"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30"></div>
    </div>

    <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 pt-32 pb-20">
      <div className="max-w-2xl">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-orange-500/20 border border-orange-500/40 rounded-full mb-6">
          <span className="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></span>
          <span className="text-orange-300 text-xs font-medium tracking-wide uppercase">Phoenix, AZ — Professional Grade Tools</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white leading-none mb-6">
          <span className="block text-orange-400">PROFESSIONAL</span>
          <span className="block">HARDWARE</span>
          <span className="block text-gray-300 font-light">TOOLS</span>
        </h1>

        <p className="text-gray-300 text-lg leading-relaxed mb-8 max-w-lg">
          From professional contractors to DIY enthusiasts — we carry 30+ premium hardware tools priced $50–$1,000. Quality you can trust, delivered to your door.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mb-10">
          <Link
            to="/products"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Shop All Products
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-white/40 text-white font-semibold rounded-lg hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            About STRAY LOFT
          </Link>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center gap-6">
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-shield-check-line text-green-400 text-lg"></i>
            <span>Stripe Secure Payment</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-truck-line text-orange-400 text-lg"></i>
            <span>Free Shipping $200+</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-star-fill text-amber-400 text-lg"></i>
            <span>4.8/5 Avg Rating</span>
          </div>
        </div>
      </div>
    </div>

    {/* Scroll indicator */}
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
      <span className="text-xs tracking-widest uppercase">Scroll</span>
      <div className="w-px h-8 bg-white/30 animate-pulse"></div>
    </div>
  </section>
);

export default HeroSection;
